import React from 'react';
import { Typography, Modal } from '@hpstellar/core/visId';
import { Helpers } from '../../../../../../core';

import './offer-modal.less';

const OfferContent = ({ offer }) => {

    return (
        <div className="offer-detailspopup">
            {offer.name && (
                <Typography variant="h5" className="title" dangerouslySetInnerHTML={Helpers.createMarkup(offer.name)} />
            )}
            {offer.longDescription && (
                <Typography
                    tag="div"
                    variant="body1"
                    className="desc"
                    dangerouslySetInnerHTML={Helpers.createMarkup(offer.longDescription)}
                />
            )}
        </div>
    );
};

const OfferModal = ({
    animationType = '',
    horizontalAlignment = 'center',
    isOpen,
    onClose,
    modalTitle,
    withBackdrop = 'backdrop-none',
    modalOffer,
    className = 'pdp-offer-modal',
    modalSubTitle = 'Offer also applies to:',
    mainProdSku,
}) => {
    return (
        <Modal
            animationType={animationType}
            horizontalAlignment={horizontalAlignment}
            isOpen={isOpen}
            className={className}
            onClose={onClose}
            modalClassName="offers-modal"
            backdropClassName={withBackdrop}
            title={modalTitle}
        >
            <OfferContent offer={modalOffer} subtite={modalSubTitle} mainProdSku={mainProdSku} />
        </Modal>
    );
};

export default OfferModal;
